module.exports = __webpack_public_path__ + "img/Frame 70807.7fb170e8.png";